<p-dropdown [inputId]="inputId" [options]="list" [(ngModel)]="selectedItem" [placeholder]="placeholderText" optionLabel="name" (onChange)="feedback()"
 autoWidth="false" [style]="{'width':'100%'}" [disabled]="disabled" [filter]="filter" filterBy="name" appendTo="body">
</p-dropdown>


